// @ts-expect-error migrate upstream
import { connect } from 'general-store';
import { useSelector } from 'react-redux';
import compose from 'transmute/compose';
// @ts-expect-error migrate upstream
import { DefaultDashboardDependency } from '../../../dependencies/DashboardDependency';
import { track as dashboardTracker, EVENTS
// @ts-expect-error migrate upstream
} from 'dashboard-ui-components/tracking/DashboardUITracker';
// @ts-expect-error migrate upstream
import { isReadOnlyDemo } from 'dashboard-lib/public/dashboard/dashboard-logic';
import { selectHasDashboardDemoWriteScope, selectIsUserAdmin
// @ts-expect-error migrate upstream
} from 'dashboard-lib/public/userInfo/scopes';
// @ts-expect-error migrate upstream
import { selectUserId } from 'dashboard-lib/public/userInfo';
// @ts-expect-error migrate upstream
import mapProps from 'dashboard-components/decorator/mapProps';
// @ts-expect-error migrate upstream
import { DashboardCountDependency } from '../../../dependencies/DashboardsDependency';
// @ts-expect-error migrate upstream
import { withUserInfo } from 'dashboard-components/context/user-info-context';
// @ts-expect-error migrate upstream
import { updateDashboardMeta } from '../../../actions/DashboardActions';
// @ts-expect-error migrate upstream
import { withDashboardPermission } from '../../../decorators/withDashboardPermission';
// @ts-expect-error migrate upstream
import DashboardDetailsAction from 'dashboard-components/dashboard-actions/DashboardDetailsAction';
// @ts-expect-error migrate upstream
import { getCustomDashboardLimitFromUserInfo } from 'dashboard-components/context/use-custom-dashboard-limit';
// @ts-expect-error migrate upstream
import { getMaxUserAssetPermissionFromUserInfo } from 'dashboard-components/context/use-max-user-asset-permission';
// @ts-expect-error migrate upstream
import { ACTION_LOCATIONS } from 'dashboard-components/usage-tracking/tracking-constants';
import { jsx as _jsx } from "react/jsx-runtime";
const DashboardDetailsButton = ({
  children,
  dashboard,
  dashboardsCount,
  customDashboardLimit,
  userAssetPermission,
  maxUserAssetPermission
}) => {
  const hasAdminAccess = useSelector(selectIsUserAdmin);
  const canWriteDemoDashboard = useSelector(selectHasDashboardDemoWriteScope);
  const userId = useSelector(selectUserId);
  return /*#__PURE__*/_jsx(DashboardDetailsAction, {
    actionLocation: ACTION_LOCATIONS.SINGLE_ASSET_VIEW,
    currentUserId: userId,
    customDashboardCount: dashboardsCount,
    customDashboardLimit: customDashboardLimit,
    dashboard: dashboard,
    isReadOnlyDemo: isReadOnlyDemo(canWriteDemoDashboard, dashboard),
    isUserAdmin: hasAdminAccess,
    maxUserAssetPermission: maxUserAssetPermission,
    onUpdate: (dashboardId, data) => updateDashboardMeta(dashboardId, data),
    trackRename: dashboardId => dashboardTracker(EVENTS.renameDashboard, {
      dashboardId
    }),
    trackChangeOwner: () => dashboardTracker(EVENTS.changeDashboardOwner),
    trackDescriptionUpdate: () => dashboardTracker(EVENTS.changeDashboardDescription, {
      subscreen: 'dashboard'
    }),
    trackShowDescriptionUpdate: value => dashboardTracker(EVENTS.changeShowDescription, {
      value,
      subscreen: 'dashboard'
    }),
    userAssetPermission: userAssetPermission,
    children: children
  });
};
export default compose(withDashboardPermission, connect({
  defaultDashboardId: DefaultDashboardDependency,
  dashboardsCount: DashboardCountDependency
}), withUserInfo, mapProps(props => {
  const {
    dashboardPermission,
    userInfo
  } = props;
  const maxUserAssetPermission = getMaxUserAssetPermissionFromUserInfo(userInfo);
  const customDashboardLimit = getCustomDashboardLimitFromUserInfo(userInfo);
  return Object.assign({
    customDashboardLimit,
    isReadOnlyDemo,
    userAssetPermission: dashboardPermission,
    maxUserAssetPermission
  }, props);
}))(DashboardDetailsButton);